import { makeVar } from '@apollo/client';
export var clubSettingsPageVar = makeVar({
    clubParticipantsSearchFieldInput: ''
});
